module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-full-c1d6d9b9df921f6a2956237e86717b7c.jpg";